document.addEventListener('DOMContentLoaded', function() {
    // Function to get a cookie by name
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    // Function to set a cookie
    function setCookie(name, value, options = {}) {
        options = {
            path: '/',
            ...options
        };

        if (options.expires instanceof Date) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    // Function to handle pincode submission
    function handlePincodeSubmission(pincode) {
        const changeButton = document.querySelector('#pincodeChangeButton');
        const messageElement = document.getElementById('pincodeDefaultMessage');
        const checkButton = document.querySelector('#pincodeCheckButton');
        const deliveryicon = document.querySelector('.pincode-checker--delivery-icon');

        changeButton.style.display = 'block';
        checkButton.style.display = 'none';

        if (!/^\d{6}$/.test(pincode)) {
            messageElement.textContent = 'Please enter a valid pincode.';
            checkButton.style.display = 'none';
            deliveryicon.style.display = 'none';
            changeButton.style.display = 'inline-block';
            return;
        }

        // Save pincode in cookie for 30 days
        setCookie('pincodeDelivery', pincode, { 'max-age': 30 * 24 * 60 * 60 });

        const resetDisplayStyles = () => {
            checkButton.style.display = 'inline-block';
            deliveryicon.style.display = 'inline-block';
            changeButton.style.display = 'none';
            messageElement.textContent = 'Enter your pincode here to check the delivery availability';
        }

        pincodeInput.addEventListener('keydown', resetDisplayStyles);
        changeButton.addEventListener('click', resetDisplayStyles);

        fetch('https://simple-shiprocket-edd.marmeto.com/api/estimate-delivery-days', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ pincode: pincode })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                const today = new Date();
                const deliveryDate = new Date();
                deliveryDate.setDate(today.getDate() + data.data);

                const options = { day: 'numeric', month: 'long', weekday: 'long' };
                const formattedDate = deliveryDate.toLocaleDateString('en-US', options);

                messageElement.textContent = `Delivery by ${formattedDate}.`;
            } else {
                messageElement.textContent = data.message + (data.error ? " - " + data.error : "");
            }
        })
        .catch(error => {
            messageElement.textContent = "Error: Unable to fetch data. Please try again later.";
            console.error('Error:', error);
        });
    }

    // Get the pincode input element
    const pincodeInput = document.getElementById('pincodeCheckerInput');

    // Check if the element exists
    if (pincodeInput) {
        // Set default pincode if not already set in cookie
        const defaultPincode = '201310';
        const savedPincode = getCookie('pincodeDelivery');

        if (savedPincode) {
            pincodeInput.value = savedPincode;
            handlePincodeSubmission(savedPincode); // Automatically submit the saved pincode
        } else {
            pincodeInput.value = defaultPincode;
            handlePincodeSubmission(defaultPincode); // Automatically submit the default pincode
        }

        document.getElementById('pincodeCheckerForm').addEventListener('submit', function(event) {
            event.preventDefault();
            handlePincodeSubmission(pincodeInput.value);
        });
    } else {
        console.error("Element with ID 'pincodeCheckerInput' not found.");
    }
});